import { inject, injectable } from 'inversify';
import { addHours } from 'date-fns';

import StorageService from '../../StorageService';

import type { BookmarksResponse, FavouritesListResponse, LineupResource, Product } from './types';

@injectable()
export default class StreamIQData {
  protected lineup: LineupResource | undefined = undefined;
  protected favoriteResources: FavouritesListResponse['resources'] = [];
  protected bookmarkResources: BookmarksResponse['resources'] = [];
  protected products: Product[] = [];
  protected purchases: { productId: string; exp: number }[] = [];

  constructor(@inject(StorageService) private readonly storageService: StorageService) {
    // retrieve existing purchases
    this.storageService.getItem('IQ-PPV', true).then((purchases) => {
      if (Array.isArray(purchases)) {
        this.purchases = purchases;
      }
    });
  }

  setLineup(lineup: LineupResource | undefined) {
    this.lineup = lineup;
  }

  getLineup() {
    return this.lineup;
  }

  setFavorites(favorites: FavouritesListResponse['resources']) {
    this.favoriteResources = favorites;
  }

  getFavorites() {
    return this.favoriteResources.filter((item) => 'resource' in item);
  }

  setBookmarks(bookmarks: BookmarksResponse['resources']) {
    this.bookmarkResources = bookmarks;
  }

  getBookmarks() {
    return this.bookmarkResources.filter((item) => 'resource' in item);
  }

  setProducts(products: Product[]) {
    this.products = products;
  }

  getProducts() {
    return this.products;
  }

  registerPurchase(productId: string, hoursAccess: number) {
    this.purchases.push({ productId, exp: addHours(new Date(), hoursAccess).getTime() });

    void this.storageService.setItem('IQ-PPV', JSON.stringify(this.purchases));
  }

  getPurchase(productId: string) {
    return this.purchases.find((purchase) => purchase.productId === productId && purchase.exp > Date.now());
  }
}
